import React from 'react';
import { Box } from '@mui/material';
import TaskList from '../components/tasks/TaskList';

const TasksPage: React.FC = () => {
  return (
    <Box>
      <TaskList />
    </Box>
  );
};

export default TasksPage;